import React from "react";
import QuoteCard from "./Components/QuoteCard";



function App() {


  return (
    <div>
     <QuoteCard/>
     
    </div>
  );
}

export default App;
